/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    readingHistoryOption: {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: `${colors.primaryDark}44`, // @TODO: abstract with friends widget
      borderRadius: 8,
      marginVertical: 2,
    },
    chapterHistoryText: {
      color: colors.white,
      fontSize: globalScale * 14,
      padding: globalScale * 4,
      paddingVertical: globalScale * 8,
    },
  };
};

export default getStyles;
